import { MissingPerson } from './MissingPerson';
import { useNicheMissingPerson } from './useNicheMissingPerson';

export function SharedMissingPerson({
  personId,
  reason,
  onShareClick,
  onShowMapClick,
}) {
  const {
    query: { data: missingPerson },
  } = useNicheMissingPerson(personId);

  return missingPerson ? (
    <MissingPerson
      missingPerson={missingPerson}
      onShowMapClick={onShowMapClick}
      onShareClick={onShareClick}
      reason={reason}
    />
  ) : null;
}
